import { type CoverageState } from "./state";

export const initialState: CoverageState = {
  zones: [],
  isPending: false,
  isRejected: false,
  errorMessage: "",
  isSaving: false,
  saveError: "",
};
